import React, { Suspense, lazy } from 'react';
import { CircularProgress } from "@material-ui/core";

const LazyArticlePage = lazy(() => import('./index'));

const ArticlePageWrapper = () => (
    <Suspense fallback={<CircularProgress />}>
        <LazyArticlePage />
    </Suspense>
);

export default ArticlePageWrapper;
